module.exports = __webpack_public_path__ + "static/domain-whois_1-62267baab53fa38a7999faed9774f4a5.jpg";